import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IOnboardingGuideStep } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';

@Component({
    selector: 'fi-quiz-editor-guide-card',
    templateUrl: './fi-quiz-editor-guide-card.component.html',
    styleUrls: ['./fi-quiz-editor-guide-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-editor-guide-card' },
    standalone: false,
})
export class FiQuizEditorGuideCardComponent {
    protected readonly guideSteps: IOnboardingGuideStep[] = [
        {
            Name: 'quiz.quiz_name',
            Description: 'quiz.name_guide_description',
        },
        {
            Name: 'quiz.add_question',
            Description: 'quiz.add_question_guide_description',
        },
        {
            Name: 'quiz.create_question',
            Description: 'quiz.create_question_guide_description',
        },
        {
            Name: 'quiz.mark_correct_choice',
            Description: 'quiz.mark_correct_choice_guide_description',
        },
        {
            Name: 'quiz.delete_option',
            Description: 'quiz.delete_option_guide_description',
        },
        {
            Name: 'common.question_delete',
            Description: 'quiz.question_delete_guide_description',
        },
    ];
}
